/*
 * @Author: Teemo Ding
 * @Date: 2022-01-20 11:10:57
 * @LastEditTime: 2022-09-06 15:30:54
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Order/AllOrders/OrderDetail/ParcelProcess/VirtualProduct/index.tsx
 */
import React, { useState } from 'react';
//import css from './css.module.less';
import Category from '../Components/Category';
import { useRequest } from 'ahooks';
import { message } from 'antd';
import { get, cloneDeep } from 'lodash';
import { useHistory } from 'react-router-dom';
import { Checkbox } from 'src/components/Antd';
import { SectionWrapper } from 'src/components/Layouts';
import { EnumProductType } from 'src/types/common/product';
import { EOperationType } from '@/src/types/common/order';
import {
  notifyVirtualItem,
  markAsDoneVirtualItem,
  undoVirtualItemService,
} from 'src/request/order';
import css from './css.module.less';
import moment from 'moment';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';

const VirtualProduct = ({
  virtualItems,
  onUpdate,
  getRequestPage,
  disabled,
}) => {
  const i18n = useI18n();
  const getI18n = (str) => {
    return i18nGet(i18n, str);
  };
  const [done, setDone] = useState([]);
  const history = useHistory();
  const virtualItemsAll = virtualItems.flatMap((item) =>
    item.productType === EnumProductType.Service
      ? item
      : (item.giftCards || []).flatMap((list) => ({
          productType: item.productType,
          giftCard: list,
          orderLineItem: item.orderLineItem,
        })),
  );
  const { run: _notifyVirtualItem } = useRequest(
    (uuid, params?) => notifyVirtualItem(uuid, params),
    {
      manual: true,
      onSuccess: (res) => {
        onUpdate(res);
        message.success(
          getI18n(
            `allOrders.orderDetail.virtualproduct__notifyVirtualItem_msgsuccess`,
          ),
        );
      },
    },
  );
  const { run: _markAsDoneVirtualItem } = useRequest(
    (uuid) => markAsDoneVirtualItem(uuid),
    {
      manual: true,
      onSuccess: (res) => {
        onUpdate(res);
        message.success(
          getI18n(
            `allOrders.orderDetail.virtualproduct_markAsDoneVirtualItem_msgsuccess`,
          ),
        );
      },
    },
  );
  const { run: _undoVirtualItemService } = useRequest(
    (uuid) => undoVirtualItemService(uuid),
    {
      manual: true,
      onSuccess: (res) => {
        onUpdate(res);
      },
    },
  );
  const handleViewDetail = (data) => {
    history.push(`/order/giftCard/edit/${data.cardUuid}`);
  };

  const handleCheck = (uuid, value) => {
    let doneClone = cloneDeep(done);
    if (value) {
      doneClone.push(uuid);
    } else {
      doneClone = doneClone.filter((o) => o !== uuid);
    }
    setDone(doneClone);
    // setDone;
  };
  return (
    <SectionWrapper
      title={`${getI18n(
        `allOrders.orderDetail.virtualproduct_return_title`,
      )} (${virtualItemsAll.length} items)`}>
      <Category
        data={(virtualItemsAll || []).map((i) => {
          const image = get(i, 'orderLineItem.image.url');
          const type = get(i, 'productType');
          const notifyRequired = get(i, 'notify');
          // const lastNotifiedDate = get(
          //   i,
          //   'orderLineItem.virtualItemProperty.lastNotifiedDate',
          // );
          const uuid = get(i, 'orderLineItem.uuid');
          const giftCardUuid = get(i, 'giftCard.uuid');
          const virtualItemsProperty =
            get(i, 'orderLineItem.virtualItemsProperty') || [];
          const targetProperty = virtualItemsProperty.find((i) => {
            return i.customerGiftCardUuid === giftCardUuid;
          });
          const serviceProperty = virtualItemsProperty[0];
          const haveNotifyCustomer = get(
            serviceProperty,
            'notifyCustomer',
            false,
          );
          const serviceMarkAsDoneDate = get(
            serviceProperty,
            'serviceMarkAsDoneDate',
          );
          const haveServiceMarkAsDone = get(
            serviceProperty,
            'serviceMarkAsDone',
          );
          const lastNotifiedDate =
            type == EnumProductType.GiftCard
              ? get(targetProperty, 'lastNotifiedDate')
              : get(serviceProperty, 'lastNotifiedDate');
          const formattedLastNotifiedData = lastNotifiedDate
            ? moment(lastNotifiedDate).format('YYYY-MM-DD HH:mm')
            : null;
          const formattedServiceMarkAsDoneDate = serviceMarkAsDoneDate
            ? moment(serviceMarkAsDoneDate).format('YYYY-MM-DD HH:mm')
            : null;
          return {
            uuid,
            image,
            sku: get(i, 'orderLineItem.productName'),
            options: [
              {
                title: getI18n(
                  `allOrders.orderDetail.virtualproduct_returndata_skutitle`,
                ),
                content: get(i, 'orderLineItem.sku') || '-',
              },
              {
                title: getI18n(
                  `allOrders.orderDetail.virtualproduct_returndata_typetitle`,
                ),
                content: type || '-',
              },
              ...(type == EnumProductType.GiftCard
                ? [
                    {
                      title: getI18n(
                        `allOrders.orderDetail.virtualproduct_returndata_options_judgeTypeGiftcard_amounttitle`,
                      ),
                      content: get(i, 'orderLineItem.originalPrice') || '-',
                    },
                    {
                      title: getI18n(
                        `allOrders.orderDetail.virtualproduct_returndata_options_judgeTypeGiftcard_redemptiontitle`,
                      ),
                      content: get(i, 'giftCard.redemptionCode') || '-',
                    },
                    {
                      title: getI18n(
                        `allOrders.orderDetail.virtualproduct_returndata_options_judgeTypeGiftcard_Expirytitle`,
                      ),
                      content: get(i, 'giftCard.expireAt') || '-',
                    },
                    {
                      title: getI18n(
                        `allOrders.orderDetail.virtualproduct_returndata_options_judgeTypeGiftcard_notifiedtitle`,
                      ),
                      content: formattedLastNotifiedData || '-',
                    },
                  ]
                : []),
              ...(type == EnumProductType.Service
                ? [
                    {
                      title: getI18n(
                        `allOrders.orderDetail.virtualproduct_returndata_options_judgeTypeService_qtytitle`,
                      ),
                      content: get(i, 'orderLineItem.amount') || '-',
                    },
                    {
                      title: getI18n(
                        `allOrders.orderDetail.virtualproduct_returndata_options_judgeTypeService_Notificationtitle`,
                      ),
                      content: notifyRequired
                        ? 'Required'
                        : 'Not required' || '-',
                    },
                    ...(serviceMarkAsDoneDate
                      ? [
                          {
                            title: getI18n(
                              `allOrders.orderDetail.virtualproduct_returndata_options_judgeTypeService_serviceMarkAsDoneDate_title`,
                            ),
                            content: formattedServiceMarkAsDoneDate,
                          },
                        ]
                      : []),
                    ...(notifyRequired && lastNotifiedDate
                      ? [
                          {
                            title: getI18n(
                              `allOrders.orderDetail.virtualproduct_returndata_options_judgeTypeGiftcard_notifiedtitle`,
                            ),
                            content: formattedLastNotifiedData,
                          },
                        ]
                      : []),
                  ]
                : []),
            ],
            hideViewDetail: type == EnumProductType.Service,
            onViewDetail: handleViewDetail,
            cardUuid: get(i, ['giftCard', 'uuid']),
            ...(type == EnumProductType.Service && {
              btns: [
                ...(notifyRequired && !haveNotifyCustomer
                  ? [
                      {
                        text: getI18n(
                          `allOrders.orderDetail.virtualproduct_returndata_notifybtns_text`,
                        ),
                        disabled: !done.includes(uuid) || disabled,
                        onClick: () => {
                          _notifyVirtualItem(uuid);
                        },
                      },
                    ]
                  : []),
                ...(!notifyRequired && !haveServiceMarkAsDone
                  ? [
                      {
                        text: getI18n(
                          `allOrders.orderDetail.virtualproduct_returndata_markbtns_text`,
                        ),
                        disabled: !done.includes(uuid) || disabled,
                        onClick: () => _markAsDoneVirtualItem(uuid),
                      },
                    ]
                  : []),
              ],
            }),
            ...(!disabled && {
              dropOptions: [
                ...(type == EnumProductType.GiftCard ||
                (type == EnumProductType.Service &&
                  notifyRequired &&
                  haveNotifyCustomer)
                  ? [
                      {
                        label: getI18n(
                          `allOrders.orderDetail.virtualproduct_returndata_notifybtns_text`,
                        ),
                        onClick: () => {
                          //Gift card
                          const customerGiftCardUuid = get(i, 'giftCard.uuid');
                          _notifyVirtualItem(uuid, { customerGiftCardUuid });
                        },
                      },
                    ]
                  : []),
                ...(type == EnumProductType.Service
                  ? [
                      {
                        label: getI18n(
                          `allOrders.orderDetail.virtualproduct_returndata_refunddropoptions_label`,
                        ),
                        onClick: () =>
                          getRequestPage(EOperationType.Refund, [uuid]),
                      },
                    ]
                  : []),
                ...(type == EnumProductType.Service &&
                !notifyRequired &&
                haveServiceMarkAsDone
                  ? [
                      {
                        label: getI18n(
                          `allOrders.orderDetail.virtualproduct_returndata_Undodropoptions_label`,
                        ),
                        onClick: () => _undoVirtualItemService(uuid),
                      },
                    ]
                  : []),
              ],
            }),
            ...(((type == EnumProductType.Service &&
              notifyRequired &&
              !haveNotifyCustomer) ||
              (type == EnumProductType.Service &&
                !notifyRequired &&
                !haveServiceMarkAsDone)) && {
              expand: (
                <div className={css.rightBottom}>
                  <Checkbox
                    checked={done.includes(uuid)}
                    onChange={(value) => handleCheck(uuid, value)}>
                    Confirm the service is done
                  </Checkbox>
                </div>
              ),
            }),
          };
        })}
      />
    </SectionWrapper>
  );
};

export default VirtualProduct;
